import type { FileUsage } from '@vedalib/editor/lib/files'
import React from 'react'
import { FileTypeEnum } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldColorPicker, FieldFile, FieldNumber, FormField } from 'components/formKit'
import Divider from 'components/uiKit/Divider'
import { Typography } from 'components/uiKit/Typography'
import { useBrandColorOptions } from 'services/Branding/fieldConfigs/useFieldConfigs'
import { t } from 'services/Translation'
import { chainName } from 'utils/form'

import type { SplitterValueFormType } from './splitterTypes'

const POSITION = genElementValueField({
  as: FieldNumber,
  name: `position`,
  label: t('elements.splitter.form.splitter'),
  defaultValue: 50,
  rules: [{ min: 0, max: 100, required: true, message: ' ' }],
  props: { width: 64 },
})

const LEFT_IMAGE = genElementValueField({
  as: FieldFile<FileUsage>,
  name: 'leftBlock.image',
  props: {
    fileType: FileTypeEnum.IMAGE,
    nullable: true,
    preview: true,
    showSource: true,
    hasObjectFit: true,
    hasAccessibility: true,
  },
})

const LEFT_OVERLAY = genElementValueField({
  as: FieldColorPicker<string | null>,
  name: 'leftBlock.overlay',
  label: t('input.label.overlay'),
  defaultValue: null,
  props: { labeled: true, resettable: true },
  useConfigs: [useBrandColorOptions],
})

const RIGHT_IMAGE = genElementValueField({
  as: FieldFile<FileUsage>,
  name: 'rightBlock.image',
  props: {
    fileType: FileTypeEnum.IMAGE,
    nullable: true,
    preview: true,
    showSource: true,
    hasObjectFit: true,
    hasAccessibility: true,
  },
})

const RIGHT_OVERLAY = genElementValueField({
  as: FieldColorPicker<string | null>,
  name: 'rightBlock.overlay',
  label: t('input.label.overlay'),
  props: { labeled: true, resettable: true },
  useConfigs: [useBrandColorOptions],
})

const SplitterFormValue: SplitterValueFormType = ({ name }) => (
  <Padding bottom gap sides>
    <Typography styleType='hint'>{t('elements.splitter.form.info')}</Typography>
    <FormField config={chainName(name, POSITION)} />
    <FormField config={chainName(name, LEFT_IMAGE)} />
    <FormField config={chainName(name, LEFT_OVERLAY)} />
    <Divider free />
    <FormField config={chainName(name, RIGHT_IMAGE)} />
    <FormField config={chainName(name, RIGHT_OVERLAY)} />
  </Padding>
)

export default React.memo(SplitterFormValue) as typeof SplitterFormValue
